import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledBox = styled(Box, {
  width: '100%',
  borderBottom: '1px solid $seafoam',
});
